export default function({ store, route, redirect, app }) {
  if (route.name !== 'maintain') {
    redirect('/maintain')
  }
}
